










import { Vue, Component, Prop } from 'vue-property-decorator';
import { BottomTabbar, Banner } from '@/components';
import * as config from './config';
import { getBaseinfo } from './api/index';
import { appShare, wxShareInfo } from '@/common/ts/common';

@Component({
  components: {
    BottomTabbar,
    Banner,
  },
})
export default class Home extends Vue {
  baseInfo: object = {};
  options = config.OPTHINES;
  created() {
    getBaseinfo().then((res: any) => (this.baseInfo = res.data));
    // 新版分享方案
    appShare({
      title: `2019重庆食尚年度金榜大型融媒体评选`,
      url: location.href,
      subtitle: '第二届“重庆美食年度金榜”活动来啦！',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '2019重庆食尚年度金榜大型融媒体评选',
      subtitle: '第二届“重庆美食年度金榜”活动来啦！',
    });
  }
}
